var _path, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSettingIcon = function SvgSettingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    d: "M30.083 11.083V3.166M19 34.833v-7.917M7.917 11.083V3.166"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.917 34.835V17.418M4.75 17.418h6.333"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.083 34.835V17.418M26.916 17.418h6.333"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.375,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.001 20.585V3.168M15.834 20.584h6.333"
  }))));
};
export default SvgSettingIcon;